export enum CustomerNotificationEvents {
  DELIVERY_SCHEDULED = 'deliveryScheduled',
  ON_THE_WAY = 'onTheWay',
  SUCCESSFUL_DELIVERY = 'successfulDelivery',
  MISSED_DELIVERY = 'missedDelivery',
  // CANCELLED_DELIVERY = 'cancelledDelivery',
}

export enum CNFailureEnum {
  DELIVERY_METHOD = 'delivery-method',
  DELIVERY_WINDOW = 'delivery-window',
  SWITCH_DELIVERY_METHOD = 'switch-delivery-method',
}

export const enrichTemplateWithOrganizationData = (body: string, organizationName: string): string => {
  const regex = /{organization_name}/g;
  return body.replace(regex, organizationName);
};
